import { render } from "./GroupsDeletePage.vue?vue&type=template&id=e2a36fd4"
import script from "./GroupsDeletePage.vue?vue&type=script&lang=js"
export * from "./GroupsDeletePage.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__